import React, { useRef, useState, useEffect, useContext } from 'react';
import './carousel.scss';
import { carouselData } from './carouselData';
import arrow from '../../assets//arrow_carousel.svg';
import { WidthContext } from '../../WidthContext';
import Hyperlink from '../Hyperlink/Hyperlink';

function Carousel({ dataIndex, carouselRef }) {
  const width = useContext(WidthContext);
  const [current, setCurrent] = useState(0);

  const container = useRef();
  const photoRef = useRef();

  const data = carouselData[dataIndex];
  const length = data.length - 1;

  const hyperlinkData = [
    {
      href: 'https://www.destinationtoronto.com/restaurants/michelin/',
      copy: 'Toronto',
      label: 'Visit The MICHELIN Guide Toronto'
    },
    {
      href: 'https://www.destinationvancouver.com/restaurants/michelin/',
      copy: 'Vancouver',
      label: 'Visit The MICHELIN Guide Vancouver'
    },
    {
      href: 'https://us-keepexploring.canada.travel/things-to-do/foodies-guide-quebec-city',
      copy: 'foodie destinations',
      label: "Read article, A Foodie's guide to Quebec City"
    },
    {
      href: 'https://us-keepexploring.canada.travel/things-to-do/8-authentic-quebec-foods-you-need-to-try',
      copy: 'discovered',
      label: 'Read article, 11 Authentic Quebec Foods You Need To Try'
    },
    {
      href: 'https://www.banffjaspercollection.com/attractions/banff-gondola/',
      copy: 'Banff Gondola',
      label: 'Visit Banff Gondola Home Page'
    }
  ];

  const handleClick = (direction) => {
    let currentI;
    container.current.style.animation = 'fade-out 0.4s linear 0s forwards';
    setTimeout(() => {
      container.current.style.animation = 'fade-in 0.4s linear 0s forwards';
      setCurrent(currentI);
    }, 500);

    if (direction === 'right') {
      if (current === length) {
        photoRef.current.style.animation = 'moveTo1R 0.4s linear 0s forwards';
      } else {
        photoRef.current.style.animation = `moveTo${current + 2}R 0.4s linear 0s forwards`;
      }
      currentI = current === length ? 0 : current + 1;
    } else {
      if (current === 0) {
        photoRef.current.style.animation = `moveTo${length + 1} 0.4s linear 0s forwards`;
      } else {
        photoRef.current.style.animation = `moveTo${current} 0.4s linear 0s forwards`;
      }

      currentI = current === 0 ? length : current - 1;
    }
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            carouselRef.current.style.opacity = '1';
          }
        });
      },
      { threshold: [0, 0.3] }
    );
    observer.observe(carouselRef.current);
  }, [carouselRef]);

  return (
    <section className={`carousel carousel--${dataIndex}`} ref={carouselRef}>
      <div
        className={
          dataIndex === 1 ? 'carousel__indicator carousel__indicator-4' : 'carousel__indicator'
        }
      >
        {data.map((content, i) => {
          return (
            <svg
              key={i}
              className={
                current === i
                  ? 'carousel__indicator__circle carousel__indicator__circle-active'
                  : 'carousel__indicator__circle'
              }
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
            >
              <circle cx="8" cy="8" r="6" />
            </svg>
          );
        })}
      </div>
      <div className="carousel__contents">
        <div className="carousel__contents__arrows">
          <button
            aria-label="Go to previous slide"
            className="carousel__contents__arrows__button"
            onClick={() => {
              handleClick('left');
            }}
          >
            <img
              src={arrow}
              alt=""
              className={`carousel__contents__arrows__arrow carousel__contents__arrows__arrow-${dataIndex} carousel__contents__arrows__arrow-left`}
            />
          </button>
          <button
            aria-label="Go to next slide"
            className="carousel__contents__arrows__button"
            onClick={() => {
              handleClick('right');
            }}
          >
            <img
              src={arrow}
              alt=""
              className={`carousel__contents__arrows__arrow carousel__contents__arrows__arrow-${dataIndex}`}
            />
          </button>
        </div>

        <div className="carousel__contents__photoContainer">
          <div className="carousel__contents__photoContainer__photos" ref={photoRef}>
            {data.map((content, i) => {
              return (
                <div key={i} className="carousel__contents__photoContainer__photos__imgs">
                  <img
                    className="carousel__contents__photoContainer__photos__img"
                    alt=""
                    src={width > 767 ? content.photo : content.photoM}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div
          className={`carousel__contents__text carousel__contents__text--${dataIndex}`}
          ref={container}
        >
          <h4 className="carouselTitle">{data[current].title}</h4>
          {data[current].title === 'A rising culinary destination' && (
            <p className="copy">
              Visitors in search of Canada’s newly-awarded MICHELIN star restaurants can head to{' '}
              <Hyperlink hyperlinkData={hyperlinkData[0]} /> or{' '}
              <Hyperlink hyperlinkData={hyperlinkData[1]} /> for now, but in Québec, there are{' '}
              plenty of other award-winning <Hyperlink hyperlinkData={hyperlinkData[2]} /> waiting
              to be <Hyperlink hyperlinkData={hyperlinkData[3]} />.
            </p>
          )}
          {data[current].title === 'Banff Gondola' && (
            <p className="copy">
              Reach new heights at the <Hyperlink hyperlinkData={hyperlinkData[4]} /> summit,
              featuring a 360-degree rooftop observation deck, contemporary interpretive center, and
              elevated restaurants.
            </p>
          )}
          <p className="copy">{data[current].copy}</p>
          {data[current].source && (
            <span className="carouselSource">
              ©{' '}
              <span className="carouselSource carouselSource--italic">{data[current].source}</span>
            </span>
          )}

          {data[current].href ? (
            <div className="carouselButton carousel__button">
              <a
                href={data[current].href}
                target="_blanc"
                rel="sponsored"
                aria-label={data[current].label}
              >
                {data[current].button}
              </a>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </section>
  );
}

export default Carousel;
